export default "__VITE_ASSET__AL$ppVle__"